import { GlobalService } from './../../services/global.service';
import { Subscription } from 'rxjs';
import { NoticiaService } from './../../services/class/noticia.service';
import { Noticia } from './../../models/noticia.model';
// default
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { LoadingService } from './../../services/loading.service';
import { HelperService } from './../../services/helper.service';
import { HttpProgressEvent } from '@angular/common/http';
import { MatSlideToggleChange, MatCheckboxChange } from '@angular/material';
import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-noticias-editar',
  templateUrl: './noticias-editar.component.html',
  styleUrls: ['./noticias-editar.component.scss']
})
export class NoticiasEditarComponent implements OnInit {

  data: Noticia = new Noticia();

  buscarSubscription: Subscription;

  fileImagemPequena: File;
  fileImagemGrande: File;
  progress: any;

  constructor(
    public helper: HelperService,
    public noticiaService: NoticiaService,
    public loadingService: LoadingService,
    public router: Router,
    public route: ActivatedRoute,
    public global: GlobalService
  ) {
  }

  ngOnInit() {
    this.route.params.subscribe(param => this.buscarData(param.id));
  }

  buscarData(id: number) {
    this.buscarSubscription = this.noticiaService.getById(id)
      .subscribe((res: Noticia) => this.data = res);
  }

  ngOnDestroy() {
    this.buscarSubscription.unsubscribe();
  }

  submit(f: NgForm) {

    if (f.invalid) {
      this.helper.formMarkAllTouched(f);
      this.helper.openSnackBar('Preencha os campos requiridos, por favor!');
      return;
    }

    this.loadingService.present('Alterando...');
    this.data.slug = this.helper.convertToSlug(this.data.titulo);

    this.noticiaService.patch(this.data)
      .subscribe((res: any) => {
        // as imagens ja foram enviadas ao selecionar o arquivo; a URL esta no proprio data
        this.router.navigate(['/noticias']).then(() => {
          this.helper.openSnackBar('Item alterado com sucesso.');
          this.loadingService.dismiss();
        })
      }, e => {
        this.helper.openSnackBar(e.error);
        this.loadingService.dismiss()
      });

  }

  onSituacaoChange(event: MatSlideToggleChange) {
    event.checked ? this.data.situacao = 'A' : this.data.situacao = 'I';
  }

  @ViewChild('fileImagemPequenaInput', { static: true }) fileImagemPequenaInput: ElementRef;
  onFileImagemPequenaSelected(files) {
    this.fileImagemPequena = files.item(0);
    this.loadingService.present('0%');
    this.submitImages(this.fileImagemPequena, '/noticia/imagemPequena?id=-99').then((res: any) => {
      this.data.imagemPequena = res.body;
      this.loadingService.dismiss();
    }).catch(() => {
      this.progress = 0;
      this.fileImagemPequenaInput.nativeElement.value = '';
      this.loadingService.dismiss();
    });
  }

  @ViewChild('fileImagemGrandeInput', { static: true }) fileImagemGrandeInput: ElementRef;
  onFileImagemGrandeSelected(files) {
    this.fileImagemGrande = files.item(0);
    this.loadingService.present('0%');
    this.submitImages(this.fileImagemGrande, '/noticia/imagemGrande?id=-99').then((res: any) => {
      this.data.imagemGrande = res.body;
      this.loadingService.dismiss();
    }).catch(() => {
      this.progress = 0;
      this.fileImagemGrandeInput.nativeElement.value = '';
      this.loadingService.dismiss();
    });
  }

  submitImages(file: File, url: string) {
    if (!file) {
      return;
    }
    return new Promise((resolve, reject) => {
      this.noticiaService.postFile(file, url, 'image')
        .subscribe((event: HttpProgressEvent | any) => {
          if (event.type === 4) {
            this.progress = 0;
            resolve(event);
          } else {
            this.progress = Math.round((event.loaded / event.total) * 100);
            if (isNaN(this.progress)) {
              this.progress = 100;
            }
            this.loadingService.title = `${this.progress}%`;
          }
        }, err => reject(err));
    });
  }

  removeImagemPequena() {
    this.data.imagemPequena = '';
  }

  removeImagemGrande() {
    this.data.imagemGrande = '';
  }
}
